export default [
    {
        name: 'Contratos',
        url: '/gescon/gerentes/contratos',
        icon: 'fa fa-file-text-o',
        regras: 'GESCON-GER-CONT-00',
        badge: {
            variant: 'primary',
            text: 'GERENTE'
        }
    },
    {
        name: 'Requisições',
        url: '/gescon/gerentes/requisicoes',
        icon: 'fa fa-file-text-o',
        regras: 'GESCON-GER-REQ-00',
        badge: {
            variant: 'primary',
            text: 'GERENTE'
        }
    },
    {
        name: 'Pagamentos',
        url: '/gescon/gerentes/pagamentos',
        icon: 'fa fa-dollar',
        regras: 'GESCON-GER-PAG-00',
        badge: {
            variant: 'primary',
            text: 'GERENTE'
        }
    },
    {
        name: 'Equipe de Apoio',
        url: '/gescon/gerentes/apoios',
        icon: 'fa fa-users',
        regras: 'GESCON-GER-APOIO-00'
    },
    {
        name: 'Serviços',
        url: '/gescon/gerentes/servicos',
        icon: 'fa fa-truck',
        regras: 'GESCON-GER-APROV-00', 
        badge: {
            variant: 'primary',
            text: 'GERENTE'
        }
    }
]
